import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const summaryService = {
    getByReportID,
};

const MODULE = {
    SUMMARY: 'report-detail-summaries',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getByReportID(id) {
    return apiHelper(API_URL).get(`/${MODULE.SUMMARY}/${id}`)
}